// this file was prevaled
// This file needs to be a JavaScript file using CommonJS to be compatiable with preval
module.exports = {
  "theme": {
    "animation": {
      "easeOutCubic": "cubic-bezier(0.33, 1, 0.68, 1)"
    },
    "borderWidths": [0, "1px"],
    "breakpoints": ["544px", "768px", "1012px", "1280px"],
    "fonts": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace"
    },
    "fontSizes": ["12px", "14px", "16px", "20px", "24px", "32px", "40px", "48px"],
    "fontWeights": {
      "light": 300,
      "normal": 400,
      "semibold": 500,
      "bold": 600
    },
    "lineHeights": {
      "condensedUltra": 1,
      "condensed": 1.25,
      "default": 1.5
    },
    "radii": ["0", "3px", "6px", "100px"],
    "sizes": {
      "small": "544px",
      "medium": "768px",
      "large": "1012px",
      "xlarge": "1280px"
    },
    "space": ["0", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"],
    "colorSchemes": {
      "light": {
        "colors": {
          "auto": {
            "black": "#1b1f23",
            "white": "#ffffff",
            "gray": ["#fafbfc", "#f6f8fa", "#e1e4e8", "#d1d5da", "#959da5", "#6a737d", "#586069", "#444d56", "#2f363d", "#24292e"],
            "blue": ["#f1f8ff", "#dbedff", "#c8e1ff", "#79b8ff", "#2188ff", "#0366d6", "#005cc5", "#044289", "#032f62", "#05264c"],
            "green": ["#f0fff4", "#dcffe4", "#bef5cb", "#85e89d", "#34d058", "#28a745", "#22863a", "#176f2c", "#165c26", "#144620"],
            "yellow": ["#fffdef", "#fffbdd", "#fff5b1", "#ffea7f", "#ffdf5d", "#ffd33d", "#f9c513", "#dbab09", "#b08800", "#735c0f"],
            "orange": ["#fff8f2", "#ffebda", "#ffd1ac", "#ffab70", "#fb8532", "#f66a0a", "#e36209", "#d15704", "#c24e00", "#a04100"],
            "red": ["#ffeef0", "#ffdce0", "#fdaeb7", "#f97583", "#ea4a5a", "#d73a49", "#cb2431", "#b31d28", "#9e1c23", "#86181d"],
            "purple": ["#f5f0ff", "#e6dcfd", "#d1bcf9", "#b392f0", "#8a63d2", "#6f42c1", "#5a32a3", "#4c2889", "#3a1d6e", "#29134e"],
            "pink": ["#ffeef8", "#fedbf0", "#f9b3dd", "#f692ce", "#ec6cb9", "#ea4aaa", "#d03592", "#b93a86", "#99306f", "#6d224f"]
          },
          "text": {
            "primary": "#24292e",
            "secondary": "#586069",
            "tertiary": "#6a737d",
            "placeholder": "#6a737d",
            "disabled": "#959da5",
            "inverse": "#ffffff",
            "link": "#0366d6",
            "danger": "#cb2431",
            "success": "#22863a",
            "warning": "#b08800",
            "white": "#ffffff"
          },
          "icon": {
            "primary": "#24292e",
            "secondary": "#586069",
            "tertiary": "#959da5",
            "info": "#0366d6",
            "danger": "#d73a49",
            "success": "#22863a",
            "warning": "#b08800"
          },
          "border": {
            "primary": "#e1e4e8",
            "secondary": "hsla(214,13%,93%,1)",
            "tertiary": "#d1d5da",
            "overlay": "#e1e4e8",
            "inverse": "#ffffff",
            "info": "#0366d6",
            "danger": "#d73a49",
            "success": "#34d058",
            "warning": "#f9c513"
          },
          "bg": {
            "canvas": "#ffffff",
            "canvasMobile": "#ffffff",
            "canvasInverse": "#24292e",
            "canvasInset": "#f6f8fa",
            "primary": "#ffffff",
            "secondary": "#fafbfc",
            "tertiary": "#f6f8fa",
            "overlay": "#ffffff",
            "backdrop": "rgba(27,31,35,0.5)",
            "info": "#f1f8ff",
            "infoInverse": "#0366d6",
            "danger": "#ffeef0",
            "dangerInverse": "#d73a49",
            "success": "#dcffe4",
            "successInverse": "#28a745",
            "warning": "#fff5b1",
            "warningInverse": "#ffd33d"
          },
          "state": {
            "hover": {
              "primaryBg": "#0366d6",
              "primaryBorder": "#0366d6",
              "primaryText": "#ffffff",
              "primaryIcon": "#ffffff",
              "secondaryBg": "#f6f8fa",
              "secondaryBorder": "#f6f8fa"
            },
            "selected": {
              "primaryBg": "#0366d6",
              "primaryBorder": "#0366d6",
              "primaryText": "#ffffff",
              "primaryIcon": "#ffffff"
            },
            "focus": {
              "border": "#0366d6"
            }
          },
          "fade": {
            "fg10": "rgba(27,31,35,0.1)",
            "fg15": "rgba(27,31,35,0.15)",
            "fg30": "rgba(27,31,35,0.3)",
            "fg50": "rgba(27,31,35,0.5)",
            "fg70": "rgba(27,31,35,0.7)",
            "fg85": "rgba(27,31,35,0.85)",
            "black10": "rgba(27,31,35,0.1)",
            "black15": "rgba(27,31,35,0.15)",
            "black30": "rgba(27,31,35,0.3)",
            "black50": "rgba(27,31,35,0.5)",
            "black70": "rgba(27,31,35,0.7)",
            "black85": "rgba(27,31,35,0.85)",
            "white10": "rgba(255,255,255,0.1)",
            "white15": "rgba(255,255,255,0.15)",
            "white30": "rgba(255,255,255,0.3)",
            "white50": "rgba(255,255,255,0.5)",
            "white70": "rgba(255,255,255,0.7)",
            "white85": "rgba(255,255,255,0.85)"
          },
          "alert": {
            "info": {
              "text": "#24292e",
              "icon": "rgba(4,66,137,0.6)",
              "bg": "#dbedff",
              "border": "rgba(4,66,137,0.2)"
            },
            "warn": {
              "text": "#24292e",
              "icon": "#b08800",
              "bg": "#fffbdd",
              "border": "rgba(176,136,0,0.2)"
            },
            "error": {
              "text": "#24292e",
              "icon": "rgba(158,28,35,0.6)",
              "bg": "#ffe3e6",
              "border": "rgba(158,28,35,0.2)"
            },
            "success": {
              "text": "#24292e",
              "icon": "rgba(23,111,44,0.8)",
              "bg": "#dcffe4",
              "border": "rgba(23,111,44,0.2)"
            }
          },
          "autocomplete": {
            "rowBorder": "hsla(214,13%,93%,1)"
          },
          "blankslate": {
            "icon": "hsla(212,8%,50%,1)"
          },
          "btn": {
            "text": "#24292e",
            "bg": "#fafbfc",
            "border": "rgba(27,31,35,0.15)",
            "hoverBg": "#f3f4f6",
            "hoverBorder": "rgba(27,31,35,0.15)",
            "activeBg": "hsla(220,14%,93%,1)",
            "activeBorder": "rgba(27,31,35,0.1)",
            "selectedBg": "hsla(220,14%,94%,1)",
            "focusBg": "#fafbfc",
            "focusBorder": "rgba(27,31,35,0.15)",
            "counterBg": "rgba(27,31,35,0.08)",
            "primary": {
              "text": "#ffffff",
              "bg": "#2ea44f",
              "border": "rgba(27,31,35,0.15)",
              "hoverBg": "#2c974b",
              "hoverBorder": "rgba(27,31,35,0.15)",
              "selectedBg": "hsla(137,55%,36%,1)",
              "disabledText": "rgba(255,255,255,0.8)",
              "disabledBg": "#94d3a2",
              "disabledBorder": "rgba(27,31,35,0.1)",
              "focusBg": "#2ea44f",
              "focusBorder": "rgba(27,31,35,0.15)",
              "icon": "rgba(255,255,255,0.8)",
              "counterBg": "rgba(255,255,255,0.2)"
            },
            "outline": {
              "text": "#0366d6",
              "hoverText": "#ffffff",
              "hoverBg": "#0366d6",
              "hoverBorder": "rgba(27,31,35,0.15)",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "hsla(212,97%,40%,1)",
              "selectedBorder": "rgba(27,31,35,0.15)",
              "disabledText": "rgba(3,102,214,0.5)",
              "disabledBg": "#fafbfc",
              "disabledCounterBg": "rgba(3,102,214,0.05)",
              "focusBorder": "rgba(27,31,35,0.15)",
              "counterBg": "rgba(3,102,214,0.1)"
            },
            "danger": {
              "text": "#d73a49",
              "hoverText": "#ffffff",
              "hoverBg": "#cb2431",
              "hoverBorder": "rgba(27,31,35,0.15)",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "hsla(354,66%,51%,1)",
              "selectedBorder": "rgba(27,31,35,0.15)",
              "disabledText": "rgba(215,58,73,0.5)",
              "disabledBg": "#fafbfc",
              "disabledCounterBg": "rgba(215,58,73,0.05)",
              "focusBorder": "rgba(27,31,35,0.15)",
              "counterBg": "rgba(215,58,73,0.1)",
              "icon": "#d73a49",
              "hoverIcon": "#ffffff"
            }
          },
          "counter": {
            "text": "#24292e",
            "bg": "rgba(209,213,218,0.5)",
            "primary": {
              "text": "#ffffff",
              "bg": "#6a737d"
            },
            "secondary": {
              "text": "#6a737d",
              "bg": "rgba(209,213,218,0.5)"
            }
          },
          "label": {
            "border": "#e1e4e8",
            "primary": {
              "text": "#24292e",
              "border": "#6a737d"
            },
            "secondary": {
              "text": "#586069",
              "border": "#e1e4e8"
            },
            "info": {
              "text": "#0366d6",
              "border": "#0366d6"
            },
            "success": {
              "text": "#22863a",
              "border": "#28a745"
            },
            "warning": {
              "text": "#735c0f",
              "border": "#b08800"
            },
            "danger": {
              "text": "#d73a49",
              "border": "#cb2431"
            },
            "orange": {
              "text": "#c24e00",
              "border": "#f66a0a"
            }
          },
          "input": {
            "bg": "#ffffff",
            "contrastBg": "#fafbfc",
            "border": "#e1e4e8",
            "disabledBg": "#f6f8fa",
            "disabledBorder": "#e1e4e8",
            "warningBorder": "#f9c513",
            "errorBorder": "#cb2431",
            "tooltip": {
              "success": {
                "text": "#144620",
                "bg": "#dcffe4",
                "border": "#34d058"
              },
              "warning": {
                "text": "#735c0f",
                "bg": "#fff5b1",
                "border": "#f9c513"
              },
              "error": {
                "text": "#86181d",
                "bg": "#ffeef0",
                "border": "#f97583"
              }
            }
          },
          "avatar": {
            "bg": "#ffffff",
            "border": "rgba(0,0,0,0)",
            "stackFade": "#d1d5da",
            "stackFadeMore": "#e1e4e8"
          },
          "toast": {
            "text": "#24292e",
            "bg": "#ffffff",
            "border": "#e1e4e8",
            "icon": "#ffffff",
            "iconBg": "#0366d6",
            "iconBorder": "rgba(0,0,0,0)",
            "success": {
              "text": "#24292e",
              "border": "#e1e4e8",
              "icon": "#ffffff",
              "iconBg": "#28a745",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "warning": {
              "text": "#24292e",
              "border": "#e1e4e8",
              "icon": "#24292e",
              "iconBg": "#ffd33d",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "danger": {
              "text": "#24292e",
              "border": "#e1e4e8",
              "icon": "#ffffff",
              "iconBg": "#d73a49",
              "iconBorder": "rgba(0,0,0,0)"
            },
            "loading": {
              "text": "#24292e",
              "border": "#e1e4e8",
              "icon": "#ffffff",
              "iconBg": "#586069",
              "iconBorder": "rgba(0,0,0,0)"
            }
          },
          "timeline": {
            "text": "#444d56",
            "badgeBg": "#e1e4e8",
            "badgeSuccessBorder": "rgba(0,0,0,0)",
            "targetBadgeBorder": "#2188ff",
            "targetBadgeShadow": "#c8e1ff"
          },
          "selectMenu": {
            "borderSecondary": "hsla(214,13%,93%,1)",
            "backdropBg": "rgba(27,31,35,0.5)",
            "backdropBorder": "rgba(0,0,0,0)",
            "tapHighlight": "rgba(209,213,218,0.5)",
            "tapFocusBg": "#dbedff"
          },
          "box": {
            "blueBorder": "#c8e1ff",
            "rowYellowBg": "#fffbdd",
            "rowBlueBg": "#f1f8ff",
            "headerBlueBg": "#f1f8ff",
            "headerBlueBorder": "#c8e1ff",
            "borderInfo": "rgba(3,102,214,0.2)",
            "bgInfo": "#f1f8ff",
            "borderWarning": "rgba(255,211,61,0.4)",
            "bgWarning": "#fffdef"
          },
          "branchName": {
            "text": "#586069",
            "icon": "hsla(212,30%,74%,1)",
            "bg": "hsla(210,100%,96%,1)",
            "link": {
              "text": "#0366d6",
              "icon": "hsla(212,30%,74%,1)",
              "bg": "hsla(210,100%,96%,1)"
            }
          },
          "markdown": {
            "codeBg": "rgba(27,31,35,0.05)",
            "frameBorder": "hsla(213,11%,89%,1)",
            "blockquoteBorder": "hsla(213,11%,89%,1)",
            "tableBorder": "hsla(213,11%,89%,1)",
            "tableTrBorder": "hsla(213,11%,80%,1)"
          },
          "menu": {
            "headingText": "#24292e",
            "borderActive": "#f9826c",
            "bgActive": "rgba(0,0,0,0)"
          },
          "sidenav": {
            "selectedBg": "#ffffff",
            "borderActive": "#f9826c"
          },
          "header": {
            "text": "rgba(255,255,255,0.7)",
            "bg": "#24292e",
            "logo": "#ffffff"
          },
          "filterItem": {
            "barBg": "hsla(210,29%,95%,1)"
          },
          "hiddenTextExpander": {
            "bg": "hsla(213,11%,89%,1)",
            "bgHover": "hsla(213,11%,80%,1)"
          },
          "dragAndDrop": {
            "border": "hsla(213,11%,79%,1)"
          },
          "uploadEnabled": {
            "border": "hsla(213,11%,89%,1)",
            "borderFocused": "hsla(212,100%,64%,1)"
          },
          "previewableCommentForm": {
            "border": "hsla(213,11%,79%,1)"
          },
          "underlinenav": {
            "border": "rgba(209,213,218,0)",
            "borderHover": "#d1d5da",
            "borderActive": "#f9826c",
            "text": "#24292e",
            "textHover": "#24292e",
            "textActive": "#24292e",
            "icon": "#959da5",
            "iconHover": "#959da5",
            "iconActive": "#24292e",
            "counterText": "#24292e",
            "counterBg": "rgba(209,213,218,0.5)"
          },
          "verifiedBadge": {
            "text": "#22863a",
            "bg": "#ffffff",
            "border": "#e1e4e8"
          },
          "socialCount": {
            "bg": "#ffffff"
          },
          "tooltip": {
            "text": "#ffffff",
            "bg": "#24292e"
          },
          "headerSearch": {
            "bg": "#24292e",
            "border": "#444d56"
          },
          "searchKeyword": {
            "hl": "#fffbdd"
          },
          "diffstat": {
            "neutralBg": "#d1d5da",
            "neutralBorder": "#d1d5da",
            "deletionBg": "#d73a49",
            "deletionBorder": "#d73a49",
            "additionBg": "#28a745",
            "additionBorder": "#28a745"
          },
          "mktg": {
            "success": "rgba(46,188,79,1)",
            "info": "rgba(16,116,231,1)",
            "bgShadeGradient": {
              "top": "rgba(27,31,35,0.065)",
              "bottom": "rgba(27,31,35,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#ffffff",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#ffffff"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#ffffff"
              },
              "outline": {
                "text": "#4969ed",
                "border": "rgba(73,105,237,0.3)",
                "hover": {
                  "text": "#3355e0",
                  "border": "rgba(51,85,224,0.5)"
                },
                "focus": {
                  "border": "#4969ed",
                  "borderInset": "rgba(73,105,237,0.5)"
                }
              },
              "dark": {
                "text": "#ffffff",
                "border": "rgba(255,255,255,0.3)",
                "hover": {
                  "text": "#ffffff",
                  "border": "rgba(255,255,255,0.5)"
                },
                "focus": {
                  "border": "#ffffff",
                  "borderInset": "rgba(255,255,255,0.5)"
                }
              }
            }
          },
          "filesExplorerIcon": "#79b8ff",
          "hlAuthorBg": "#f1f8ff",
          "hlAuthorBorder": "#c8e1ff",
          "logoSubdued": "#d1d5da",
          "discussionBorder": "hsla(135,28%,72%,1)",
          "discussionBgSuccess": "#28a745",
          "actionsWorkflowTableStickyBg": "rgba(255,255,255,0.95)",
          "repoLanguageColorBorder": "rgba(27,31,35,0.1)",
          "codeSelectionBg": "#c8e1ff",
          "highlight": {
            "text": "#442c12",
            "bg": "#fff0bb"
          },
          "blob": {
            "lineHighlightBg": "#fffbdd",
            "lineHighlightBorder": "rgba(0,0,0,0)"
          },
          "diff": {
            "addition": {
              "text": "#22863a",
              "bg": "hsla(136,100%,95%,1)",
              "border": "#34d058"
            },
            "deletion": {
              "text": "#cb2431",
              "bg": "#ffeef0",
              "border": "#d73a49"
            },
            "change": {
              "text": "#b08800",
              "bg": "#fff5b1",
              "border": "#f9c513"
            }
          },
          "diffBlob": {
            "numText": "rgba(27,31,35,0.3)",
            "numHoverText": "rgba(27,31,35,0.6)",
            "addition": {
              "numText": "rgba(27,31,35,0.3)",
              "numHoverText": "rgba(27,31,35,0.6)",
              "numBg": "hsla(134,100%,90%,1)",
              "lineBg": "hsla(136,100%,95%,1)",
              "wordBg": "hsla(134,73%,81%,1)"
            },
            "deletion": {
              "numText": "rgba(27,31,35,0.3)",
              "numHoverText": "rgba(27,31,35,0.6)",
              "numBg": "#ffdce0",
              "lineBg": "#ffeef0",
              "wordBg": "hsla(353,95%,86%,1)"
            },
            "hunk": {
              "text": "rgba(27,31,35,0.7)",
              "numBg": "#dbedff",
              "lineBg": "#f1f8ff"
            },
            "emptyBlockBg": "#fafbfc",
            "selectedLineHighlightBg": "rgba(255,223,93,0.2)",
            "selectedLineHighlightBorder": "#ffd33d",
            "expander": {
              "icon": "#586069",
              "hoverIcon": "#ffffff",
              "hoverBg": "#0366d6"
            },
            "commentButton": {
              "icon": "#ffffff",
              "bg": "#0366d6",
              "gradientBg": "hsla(212,97%,48%,1)"
            }
          },
          "globalNav": {
            "logo": "#ffffff",
            "bg": "#24292e",
            "text": "#ffffff",
            "icon": "#ffffff",
            "inputBg": "#fafbfc",
            "inputBorder": "#fafbfc",
            "inputIcon": "#d1d5da",
            "inputPlaceholder": "#959da5"
          },
          "footerInvertocat": {
            "octicon": "#d1d5da",
            "octiconHover": "#6a737d"
          },
          "prState": {
            "draft": {
              "text": "#ffffff",
              "bg": "#6a737d",
              "border": "rgba(0,0,0,0)"
            },
            "open": {
              "text": "#ffffff",
              "bg": "#28a745",
              "border": "rgba(0,0,0,0)"
            },
            "merged": {
              "text": "#ffffff",
              "bg": "#6f42c1",
              "border": "rgba(0,0,0,0)"
            },
            "closed": {
              "text": "#ffffff",
              "bg": "#d73a49",
              "border": "rgba(0,0,0,0)"
            }
          },
          "topicTag": {
            "text": "#0366d6",
            "bg": "#f1f8ff",
            "hoverBg": "hsla(210,100%,93%,1)",
            "activeBg": "hsla(210,100%,95%,1)"
          },
          "mergeBox": {
            "successIconBg": "#28a745",
            "successIconText": "#ffffff",
            "successIconBorder": "rgba(0,0,0,0)",
            "successIndicatorBg": "#28a745",
            "successIndicatorBorder": "rgba(0,0,0,0)",
            "mergedIconBg": "#6f42c1",
            "mergedIconText": "#ffffff",
            "mergedIconBorder": "rgba(0,0,0,0)",
            "mergedBoxBorder": "#6f42c1",
            "neutralIconBg": "#6a737d",
            "neutralIconText": "#ffffff",
            "neutralIconBorder": "rgba(0,0,0,0)",
            "neutralIndicatorBg": "#6a737d",
            "neutralIndicatorBorder": "rgba(0,0,0,0)",
            "warningIconBg": "#dbab09",
            "warningIconText": "#ffffff",
            "warningIconBorder": "rgba(0,0,0,0)",
            "warningBoxBorder": "#ffd33d",
            "warningMergeHighlight": "rgba(0,0,0,0)",
            "errorIconBg": "#d73a49",
            "errorIconText": "#ffffff",
            "errorIconBorder": "rgba(0,0,0,0)",
            "errorIndicatorBg": "#d73a49",
            "errorIndicatorBorder": "rgba(0,0,0,0)"
          },
          "project": {
            "cardBg": "#ffffff",
            "headerBg": "#24292e",
            "sidebarBg": "#ffffff",
            "gradientIn": "#ffffff",
            "gradientOut": "rgba(255,255,255,0)"
          },
          "checks": {
            "bg": "#24292e",
            "textPrimary": "#fafbfc",
            "textSecondary": "#959da5",
            "textLink": "#79b8ff",
            "btnIcon": "#d1d5da",
            "btnHoverIcon": "#fafbfc",
            "btnHoverBg": "rgba(255,255,255,0.125)",
            "inputText": "#f6f8fa",
            "inputPlaceholderText": "#959da5",
            "inputFocusText": "#959da5",
            "inputBg": "#2f363d",
            "donutError": "#cb2431",
            "donutPending": "#dbab09",
            "donutSuccess": "#28a745",
            "donutNeutral": "#959da5",
            "dropdownText": "#d1d5da",
            "dropdownBg": "#2f363d",
            "dropdownBorder": "#444d56",
            "dropdownHoverText": "#fafbfc",
            "dropdownHoverBg": "#444d56",
            "dropdownBtnHoverText": "#fafbfc",
            "dropdownBtnHoverBg": "#2f363d",
            "scrollbarThumbBg": "#586069",
            "headerLabelText": "#e1e4e8",
            "headerLabelOpenText": "#fafbfc",
            "headerBorder": "#2f363d",
            "headerIcon": "#959da5",
            "lineText": "#e1e4e8",
            "lineNumText": "rgba(149,157,165,0.75)",
            "lineTimestampText": "#959da5",
            "lineHoverBg": "#2f363d",
            "lineSelectedBg": "rgba(33,136,255,0.15)",
            "lineSelectedNumText": "#79b8ff",
            "lineDtFmText": "#24292e",
            "lineDtFmBg": "#ffd33d",
            "gateBg": "rgba(249,197,19,0.15)",
            "gateText": "#e1e4e8",
            "gateWaitingText": "#d1d5da",
            "stepHeaderOpenBg": "#2f363d",
            "stepErrorText": "#f97583",
            "stepWarningText": "#ffea7f",
            "loglineText": "#959da5",
            "loglineNumText": "rgba(149,157,165,0.75)",
            "loglineDebugText": "#b392f0",
            "loglineErrorText": "#e1e4e8",
            "loglineErrorNumText": "#f97583",
            "loglineErrorBg": "rgba(203,36,49,0.15)",
            "loglineWarningText": "#e1e4e8",
            "loglineWarningNumText": "#ffea7f",
            "loglineWarningBg": "rgba(249,197,19,0.15)",
            "loglineCommandText": "#79b8ff",
            "loglineSectionText": "#85e89d",
            "ansi": {
              "black": "#24292e",
              "blackBright": "#2f363d",
              "white": "#e1e4e8",
              "whiteBright": "#e1e4e8",
              "gray": "#959da5",
              "red": "#f97583",
              "redBright": "#fdaeb7",
              "green": "#85e89d",
              "greenBright": "#bef5cb",
              "yellow": "#ffea7f",
              "yellowBright": "#fff5b1",
              "blue": "#79b8ff",
              "blueBright": "#c8e1ff",
              "magenta": "#b392f0",
              "magentaBright": "#d1bcf9",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "introShelf": {
            "gradientLeft": "#f1f8ff",
            "gradientRight": "#dcffe4",
            "gradientIn": "#ffffff",
            "gradientOut": "rgba(255,255,255,0)"
          },
          "marketingIcon": {
            "primary": "#2188ff",
            "secondary": "#79b8ff"
          },
          "prettylights": {
            "syntax": {
              "comment": "#6a737d",
              "constant": "#005cc5",
              "entity": "#6f42c1",
              "storageModifierImport": "#24292e",
              "entityTag": "#22863a",
              "keyword": "#d73a49",
              "string": "#032f62",
              "variable": "#e36209",
              "brackethighlighterUnmatched": "#b31d28",
              "invalidIllegalText": "#fafbfc",
              "invalidIllegalBg": "#b31d28",
              "carriageReturnText": "#fafbfc",
              "carriageReturnBg": "#d73a49",
              "stringRegexp": "#22863a",
              "markupList": "#735c0f",
              "markupHeading": "#005cc5",
              "markupItalic": "#24292e",
              "markupBold": "#24292e",
              "markupDeletedText": "#b31d28",
              "markupDeletedBg": "#ffeef0",
              "markupInsertedText": "#22863a",
              "markupInsertedBg": "#f0fff4",
              "markupChangedText": "#e36209",
              "markupChangedBg": "#ffebda",
              "markupIgnoredText": "#f6f8fa",
              "markupIgnoredBg": "#005cc5",
              "metaDiffRange": "#6f42c1",
              "brackethighlighterAngle": "#586069",
              "sublimelinterGutterMark": "#959da5",
              "constantOtherReferenceLink": "#032f62"
            }
          },
          "codemirror": {
            "text": "#24292e",
            "bg": "#ffffff",
            "guttersBg": "#ffffff",
            "guttermarkerText": "#ffffff",
            "guttermarkerSubtleText": "#d1d5da",
            "linenumberText": "#959da5",
            "cursor": "#24292e",
            "selectionBg": "#c8e1ff",
            "activelineBg": "#fafbfc",
            "matchingbracketText": "#24292e",
            "linesBg": "#ffffff",
            "syntax": {
              "comment": "#6a737d",
              "constant": "#005cc5",
              "entity": "#6f42c1",
              "keyword": "#d73a49",
              "storage": "#d73a49",
              "string": "#032f62",
              "support": "#005cc5",
              "variable": "#e36209"
            }
          },
          "ansi": {
            "black": "#24292e",
            "blackBright": "#586069",
            "white": "#6a737d",
            "whiteBright": "#959da5",
            "gray": "#6a737d",
            "red": "#d73a49",
            "redBright": "#cb2431",
            "green": "#22863a",
            "greenBright": "#28a745",
            "yellow": "#b08800",
            "yellowBright": "#dbab09",
            "blue": "#0366d6",
            "blueBright": "#2188ff",
            "magenta": "#6f42c1",
            "magentaBright": "#8a63d2",
            "cyan": "#1b7c83",
            "cyanBright": "#3192aa"
          }
        },
        "shadows": {
          "shadow": {
            "small": "0 1px 0 rgba(27,31,35,0.04)",
            "medium": "0 3px 6px rgba(149,157,165,0.15)",
            "large": "0 8px 24px rgba(149,157,165,0.2)",
            "extraLarge": "0 12px 48px rgba(149,157,165,0.3)",
            "highlight": "inset 0 1px 0 rgba(255,255,255,0.25)",
            "inset": "inset 0 1px 0 rgba(225,228,232,0.2)"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px rgba(3,102,214,0.3)"
            }
          },
          "autocomplete": {
            "shadow": "0 3px 6px rgba(149,157,165,0.15)"
          },
          "btn": {
            "shadow": "0 1px 0 rgba(27,31,35,0.04)",
            "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.25)",
            "focusShadow": "0 0 0 3px rgba(3,102,214,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(27,31,35,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(3,102,214,0.3)",
            "primary": {
              "shadow": "0 1px 0 rgba(27,31,35,0.1)",
              "insetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(20,70,32,0.2)",
              "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(27,31,35,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(5,38,76,0.2)",
              "focusShadow": "0 0 0 3px rgba(0,92,197,0.4)"
            },
            "danger": {
              "hoverShadow": "0 1px 0 rgba(27,31,35,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(255,255,255,0.03)",
              "selectedShadow": "inset 0 1px 0 rgba(134,24,29,0.2)",
              "focusShadow": "0 0 0 3px rgba(203,36,49,0.4)"
            }
          },
          "dropdown": {
            "shadow": "0 8px 24px rgba(149,157,165,0.2)"
          },
          "overlay": {
            "shadow": "0 1px 3px rgba(27,31,35,0.12), 0 8px 24px rgba(68,77,86,0.12)"
          },
          "input": {
            "shadow": "inset 0 1px 2px rgba(27,31,35,0.075)"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 rgba(255,255,255,0.8)"
          },
          "toast": {
            "shadow": "0 8px 24px rgba(149,157,165,0.2)"
          },
          "selectMenu": {
            "shadow": "0 0 18px rgba(27,31,35,0.4)"
          }
        }
      },
      "dark": {
        "colors": {
          "auto": {
            "black": "#f0f6fc",
            "white": "#010409",
            "gray": ["#0d1117", "#161b22", "#21262d", "#30363d", "#484f58", "#6e7681", "#8b949e", "#b1bac4", "#c9d1d9", "#f0f6fc"],
            "blue": ["#051d4d", "#0c2d6b", "#0d419d", "#1158c7", "#1f6feb", "#388bfd", "#58a6ff", "#79c0ff", "#a5d6ff", "#cae8ff"],
            "green": ["#04260f", "#033a16", "#0f5323", "#196c2e", "#238636", "#2ea043", "#3fb950", "#56d364", "#7ee787", "#aff5b4"],
            "yellow": ["#341a00", "#4b2900", "#693e00", "#845306", "#9e6a03", "#bb8009", "#d29922", "#e3b341", "#f2cc60", "#f8e3a1"],
            "orange": ["#3d1300", "#5a1e02", "#762d0a", "#9b4215", "#bd561d", "#db6d28", "#f0883e", "#ffa657", "#ffc680", "#ffdfb6"],
            "red": ["#490202", "#67060c", "#8e1519", "#b62324", "#da3633", "#f85149", "#ff7b72", "#ffa198", "#ffc1ba", "#ffdcd7"],
            "purple": ["#271052", "#3c1e70", "#553098", "#6e40c9", "#8957e5", "#a371f7", "#bc8cff", "#d2a8ff", "#e2c5ff", "#eddeff"],
            "pink": ["#42062a", "#5e103e", "#7d2457", "#9e3670", "#bf4b8a", "#db61a2", "#f778ba", "#ff9bce", "#ffbedd", "#ffdaec"]
          },
          "text": {
            "primary": "#c9d1d9",
            "secondary": "#8b949e",
            "tertiary": "#8b949e",
            "placeholder": "#484f58",
            "disabled": "#484f58",
            "inverse": "#0d1117",
            "link": "#58a6ff",
            "danger": "#f85149",
            "success": "#56d364",
            "warning": "#e3b341",
            "white": "#f0f6fc"
          },
          "icon": {
            "primary": "#c9d1d9",
            "secondary": "#6e7681",
            "tertiary": "#484f58",
            "info": "#58a6ff",
            "danger": "#f85149",
            "success": "#56d364",
            "warning": "#e3b341"
          },
          "border": {
            "primary": "#30363d",
            "secondary": "#21262d",
            "tertiary": "#6e7681",
            "overlay": "#30363d",
            "inverse": "#f0f6fc",
            "info": "rgba(56,139,253,0.4)",
            "danger": "rgba(248,81,73,0.4)",
            "success": "rgba(63,185,80,0.4)",
            "warning": "rgba(187,128,9,0.4)"
          },
          "bg": {
            "canvas": "#0d1117",
            "canvasMobile": "#010409",
            "canvasInverse": "#f0f6fc",
            "canvasInset": "hsla(216,28%,5%,1)",
            "primary": "#0d1117",
            "secondary": "#0d1117",
            "tertiary": "#161b22",
            "overlay": "rgba(28,33,40,1)",
            "backdrop": "rgba(1,4,9,0.8)",
            "info": "rgba(56,139,253,0.1)",
            "infoInverse": "#388bfd",
            "danger": "rgba(248,81,73,0.1)",
            "dangerInverse": "#da3633",
            "success": "rgba(46,160,67,0.1)",
            "successInverse": "#2ea043",
            "warning": "rgba(187,128,9,0.1)",
            "warningInverse": "#bb8009"
          },
          "state": {
            "hover": {
              "primaryBg": "#1f6feb",
              "primaryBorder": "#388bfd",
              "primaryText": "#f0f6fc",
              "primaryIcon": "#f0f6fc",
              "secondaryBg": "#161b22",
              "secondaryBorder": "#161b22"
            },
            "selected": {
              "primaryBg": "#1f6feb",
              "primaryBorder": "#388bfd",
              "primaryText": "#f0f6fc",
              "primaryIcon": "#f0f6fc"
            },
            "focus": {
              "border": "#388bfd"
            }
          },
          "fade": {
            "fg10": "rgba(240,246,252,0.1)",
            "fg15": "rgba(240,246,252,0.15)",
            "fg30": "rgba(240,246,252,0.3)",
            "fg50": "rgba(240,246,252,0.5)",
            "fg70": "rgba(240,246,252,0.7)",
            "fg85": "rgba(240,246,252,0.85)",
            "black10": "rgba(1,4,9,0.1)",
            "black15": "rgba(1,4,9,0.15)",
            "black30": "rgba(1,4,9,0.3)",
            "black50": "rgba(1,4,9,0.5)",
            "black70": "rgba(1,4,9,0.7)",
            "black85": "rgba(1,4,9,0.85)",
            "white10": "rgba(240,246,252,0.1)",
            "white15": "rgba(240,246,252,0.15)",
            "white30": "rgba(240,246,252,0.3)",
            "white50": "rgba(240,246,252,0.5)",
            "white70": "rgba(240,246,252,0.7)",
            "white85": "rgba(240,246,252,0.85)"
          },
          "alert": {
            "info": {
              "text": "#79c0ff",
              "icon": "#79c0ff",
              "bg": "rgba(56,139,253,0.1)",
              "border": "rgba(56,139,253,0.4)"
            },
            "warn": {
              "text": "#e3b341",
              "icon": "#e3b341",
              "bg": "rgba(187,128,9,0.1)",
              "border": "rgba(187,128,9,0.4)"
            },
            "error": {
              "text": "#ff7b72",
              "icon": "#ff7b72",
              "bg": "rgba(248,81,73,0.1)",
              "border": "rgba(248,81,73,0.4)"
            },
            "success": {
              "text": "#56d364",
              "icon": "#56d364",
              "bg": "rgba(46,160,67,0.1)",
              "border": "rgba(46,160,67,0.4)"
            }
          },
          "autocomplete": {
            "rowBorder": "#30363d"
          },
          "blankslate": {
            "icon": "hsla(214,10%,36%,1)"
          },
          "btn": {
            "text": "#c9d1d9",
            "bg": "#21262d",
            "border": "#30363d",
            "hoverBg": "#30363d",
            "hoverBorder": "#8b949e",
            "activeBg": "hsla(212,12%,18%,1)",
            "activeBorder": "#6e7681",
            "selectedBg": "#161b22",
            "focusBg": "#21262d",
            "focusBorder": "#8b949e",
            "primary": {
              "text": "#ffffff",
              "bg": "#238636",
              "border": "#2ea043",
              "hoverBg": "#2ea043",
              "hoverBorder": "#3fb950",
              "selectedBg": "#238636",
              "disabledText": "rgba(240,246,252,0.5)",
              "disabledBg": "rgba(35,134,54,0.6)",
              "disabledBorder": "rgba(0,0,0,0)",
              "focusBg": "#238636",
              "focusBorder": "#3fb950",
              "icon": "#f0f6fc",
              "counterBg": "rgba(240,246,252,0.2)"
            },
            "outline": {
              "text": "#58a6ff",
              "hoverText": "#58a6ff",
              "hoverBg": "#30363d",
              "hoverBorder": "#58a6ff",
              "hoverCounterBg": "rgba(240,246,252,0.2)",
              "selectedText": "#f0f6fc",
              "selectedBg": "#0d419d",
              "selectedBorder": "rgba(240,246,252,0.1)",
              "disabledText": "rgba(88,166,255,0.5)",
              "disabledBg": "#0d1117",
              "disabledCounterBg": "rgba(31,111,235,0.05)",
              "focusBorder": "#58a6ff",
              "counterBg": "rgba(31,111,235,0.1)"
            },
            "danger": {
              "text": "#f85149",
              "hoverText": "#ffffff",
              "hoverBg": "#da3633",
              "hoverBorder": "#f85149",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "#b62324",
              "selectedBorder": "rgba(240,246,252,0.1)",
              "disabledText": "rgba(248,81,73,0.5)",
              "disabledBg": "#0d1117",
              "disabledCounterBg": "rgba(218,54,51,0.05)",
              "focusBorder": "#f85149",
              "counterBg": "rgba(218,54,51,0.1)",
              "icon": "#f85149",
              "hoverIcon": "#f0f6fc"
            },
            "counterBg": "#30363d"
          },
          "counter": {
            "text": "#c9d1d9",
            "bg": "#30363d",
            "primary": {
              "text": "#c9d1d9",
              "bg": "#6e7681"
            },
            "secondary": {
              "text": "#8b949e",
              "bg": "rgba(139,148,158,0.2)"
            }
          },
          "label": {
            "border": "#30363d",
            "primary": {
              "text": "#b1bac4",
              "border": "#6e7681"
            },
            "secondary": {
              "text": "#8b949e",
              "border": "#30363d"
            },
            "info": {
              "text": "#388bfd",
              "border": "rgba(56,139,253,0.4)"
            },
            "success": {
              "text": "#3fb950",
              "border": "rgba(46,160,67,0.4)"
            },
            "warning": {
              "text": "#e3b341",
              "border": "rgba(242,211,91,0.4)"
            },
            "danger": {
              "text": "#f85149",
              "border": "rgba(248,81,73,0.4)"
            },
            "orange": {
              "text": "#db6d28",
              "border": "rgba(219,109,40,0.4)"
            }
          },
          "input": {
            "bg": "#0d1117",
            "contrastBg": "rgba(1,4,9,0.5)",
            "border": "#21262d",
            "disabledBg": "#161b22",
            "disabledBorder": "#30363d",
            "warningBorder": "#d29922",
            "errorBorder": "#f85149",
            "tooltip": {
              "success": {
                "text": "#56d364",
                "bg": "rgba(16,31,27,1)",
                "border": "rgba(28,83,43,1)"
              },
              "warning": {
                "text": "#e3b341",
                "bg": "rgba(30,28,22,1)",
                "border": "rgba(93,68,17,1)"
              },
              "error": {
                "text": "#ff7b72",
                "bg": "rgba(37,23,28,1)",
                "border": "rgba(121,46,46,1)"
              }
            }
          },
          "avatar": {
            "bg": "rgba(240,246,252,0.1)",
            "border": "rgba(240,246,252,0.1)",
            "stackFade": "#30363d",
            "stackFadeMore": "#21262d"
          },
          "toast": {
            "text": "#c9d1d9",
            "bg": "#30363d",
            "border": "#6e7681",
            "icon": "#f0f6fc",
            "iconBg": "#1f6feb",
            "iconBorder": "#388bfd",
            "success": {
              "text": "#c9d1d9",
              "border": "#6e7681",
              "icon": "#f0f6fc",
              "iconBg": "#2ea043",
              "iconBorder": "#3fb950"
            },
            "warning": {
              "text": "#c9d1d9",
              "border": "#6e7681",
              "icon": "#f0f6fc",
              "iconBg": "#bb8009",
              "iconBorder": "#d29922"
            },
            "danger": {
              "text": "#c9d1d9",
              "border": "#6e7681",
              "icon": "#f0f6fc",
              "iconBg": "#da3633",
              "iconBorder": "#f85149"
            },
            "loading": {
              "text": "#c9d1d9",
              "border": "#6e7681",
              "icon": "#f0f6fc",
              "iconBg": "#6e7681",
              "iconBorder": "#8b949e"
            }
          },
          "timeline": {
            "text": "#b1bac4",
            "badgeBg": "#0d1117",
            "badgeSuccessBorder": "#2ea043",
            "targetBadgeBorder": "#1f6feb",
            "targetBadgeShadow": "#0d419d"
          },
          "selectMenu": {
            "borderSecondary": "#30363d",
            "backdropBg": "rgba(1,4,9,0.5)",
            "backdropBorder": "#484f58",
            "tapHighlight": "rgba(48,54,61,0.5)",
            "tapFocusBg": "#0c2d6b"
          },
          "box": {
            "blueBorder": "#0d419d",
            "rowYellowBg": "rgba(235,196,64,0.1)",
            "rowBlueBg": "rgba(121,192,255,0.1)",
            "headerBlueBg": "#0d1117",
            "headerBlueBorder": "#30363d",
            "borderInfo": "rgba(56,139,253,0.4)",
            "bgInfo": "rgba(56,139,253,0.1)",
            "borderWarning": "rgba(187,128,9,0.4)",
            "bgWarning": "rgba(187,128,9,0.1)"
          },
          "branchName": {
            "text": "#c9d1d9",
            "icon": "#b1bac4",
            "bg": "rgba(88,166,255,0.1)",
            "link": {
              "text": "#58a6ff",
              "icon": "#58a6ff",
              "bg": "rgba(88,166,255,0.1)"
            }
          },
          "markdown": {
            "codeBg": "rgba(240,246,252,0.15)",
            "frameBorder": "hsla(212,12%,26%,1)",
            "blockquoteBorder": "hsla(212,12%,26%,1)",
            "tableBorder": "hsla(212,12%,26%,1)",
            "tableTrBorder": "hsla(212,12%,17%,1)"
          },
          "menu": {
            "headingText": "#8b949e",
            "borderActive": "#f78166",
            "bgActive": "#161b22"
          },
          "sidenav": {
            "selectedBg": "#21262d",
            "borderActive": "#f78166"
          },
          "header": {
            "text": "rgba(240,246,252,0.7)",
            "bg": "#161b22",
            "logo": "#f0f6fc"
          },
          "filterItem": {
            "barBg": "hsla(215,21%,9%,1)"
          },
          "hiddenTextExpander": {
            "bg": "#21262d",
            "bgHover": "#30363d"
          },
          "dragAndDrop": {
            "border": "hsla(212,12%,16%,1)"
          },
          "uploadEnabled": {
            "border": "hsla(212,12%,26%,1)",
            "borderFocused": "hsla(216,84%,60%,1)"
          },
          "previewableCommentForm": {
            "border": "hsla(212,12%,16%,1)"
          },
          "underlinenav": {
            "border": "rgba(48,54,61,0)",
            "borderHover": "#30363d",
            "borderActive": "#f78166",
            "text": "#8b949e",
            "textHover": "#c9d1d9",
            "textActive": "#c9d1d9",
            "icon": "#6e7681",
            "iconHover": "#c9d1d9",
            "iconActive": "#c9d1d9",
            "counterText": "#8b949e",
            "counterBg": "rgba(139,148,158,0.2)"
          },
          "verifiedBadge": {
            "text": "#3fb950",
            "bg": "rgba(63,185,80,0.1)",
            "border": "rgba(63,185,80,0.4)"
          },
          "socialCount": {
            "bg": "#21262d"
          },
          "tooltip": {
            "text": "#f0f6fc",
            "bg": "#6e7681"
          },
          "headerSearch": {
            "bg": "#0d1117",
            "border": "#21262d"
          },
          "searchKeyword": {
            "hl": "rgba(187,128,9,0.4)"
          },
          "diffstat": {
            "neutralBg": "#30363d",
            "neutralBorder": "rgba(240,246,252,0.1)",
            "deletionBg": "#da3633",
            "deletionBorder": "#f85149",
            "additionBg": "#238636",
            "additionBorder": "#2ea043"
          },
          "mktg": {
            "success": "rgba(41,147,61,1)",
            "info": "rgba(42,123,243,1)",
            "bgShadeGradient": {
              "top": "rgba(1,4,9,0.065)",
              "bottom": "rgba(1,4,9,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#f0f6fc",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#f0f6fc"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#f0f6fc"
              },
              "outline": {
                "text": "#f0f6fc",
                "border": "rgba(240,246,252,0.3)",
                "hover": {
                  "text": "#f0f6fc",
                  "border": "rgba(240,246,252,0.5)"
                },
                "focus": {
                  "border": "#f0f6fc",
                  "borderInset": "rgba(240,246,252,0.5)"
                }
              },
              "dark": {
                "text": "#f0f6fc",
                "border": "rgba(240,246,252,0.3)",
                "hover": {
                  "text": "#f0f6fc",
                  "border": "rgba(240,246,252,0.5)"
                },
                "focus": {
                  "border": "#f0f6fc",
                  "borderInset": "rgba(240,246,252,0.5)"
                }
              }
            }
          },
          "filesExplorerIcon": "#6e7681",
          "hlAuthorBg": "#051d4d",
          "hlAuthorBorder": "#0d419d",
          "logoSubdued": "#30363d",
          "discussionBorder": "hsla(135,22%,26%,1)",
          "discussionBgSuccess": "rgba(46,160,67,0.1)",
          "actionsWorkflowTableStickyBg": "rgba(13,17,23,0.95)",
          "repoLanguageColorBorder": "rgba(240,246,252,0.2)",
          "codeSelectionBg": "rgba(121,192,255,0.3)",
          "highlight": {
            "text": "#ffd467",
            "bg": "rgba(204,143,44,0.38)"
          },
          "blob": {
            "lineHighlightBg": "rgba(210,153,34,0.15)",
            "lineHighlightBorder": "#e3b341"
          },
          "diff": {
            "addition": {
              "text": "#56d364",
              "bg": "rgba(46,160,67,0.2)",
              "border": "#196c2e"
            },
            "deletion": {
              "text": "#f85149",
              "bg": "rgba(218,54,51,0.2)",
              "border": "#b62324"
            },
            "change": {
              "text": "#e3b341",
              "bg": "#341a00",
              "border": "#9e6a03"
            }
          },
          "diffBlob": {
            "numText": "rgba(240,246,252,0.3)",
            "numHoverText": "rgba(240,246,252,0.6)",
            "addition": {
              "numText": "#3fb950",
              "numHoverText": "#7ee787",
              "numBg": "rgba(46,160,67,0.1)",
              "lineBg": "rgba(46,160,67,0.2)",
              "wordBg": "rgba(46,160,67,0.55)"
            },
            "deletion": {
              "numText": "#f85149",
              "numHoverText": "#ffa198",
              "numBg": "rgba(218,54,51,0.1)",
              "lineBg": "rgba(218,54,51,0.2)",
              "wordBg": "rgba(218,54,51,0.5)"
            },
            "hunk": {
              "text": "#8b949e",
              "numBg": "rgba(88,166,255,0.15)",
              "lineBg": "rgba(88,166,255,0.1)"
            },
            "emptyBlockBg": "#161b22",
            "selectedLineHighlightBg": "rgba(187,128,9,0.1)",
            "selectedLineHighlightBorder": "#bb8009",
            "expander": {
              "icon": "#8b949e",
              "hoverIcon": "#f0f6fc",
              "hoverBg": "#1f6feb"
            },
            "commentButton": {
              "icon": "#f0f6fc",
              "bg": "#1f6feb",
              "gradientBg": "hsla(216,84%,57%,1)"
            }
          },
          "globalNav": {
            "logo": "#f0f6fc",
            "bg": "#161b22",
            "text": "#c9d1d9",
            "icon": "#c9d1d9",
            "inputBg": "#0d1117",
            "inputBorder": "#21262d",
            "inputIcon": "#21262d",
            "inputPlaceholder": "#484f58"
          },
          "footerInvertocat": {
            "octicon": "#30363d",
            "octiconHover": "#6e7681"
          },
          "prState": {
            "draft": {
              "text": "#8b949e",
              "bg": "rgba(139,148,158,0.1)",
              "border": "rgba(139,148,158,0.4)"
            },
            "open": {
              "text": "#3fb950",
              "bg": "rgba(63,185,80,0.1)",
              "border": "rgba(63,185,80,0.4)"
            },
            "merged": {
              "text": "#a371f7",
              "bg": "rgba(188,140,255,0.1)",
              "border": "rgba(188,140,255,0.4)"
            },
            "closed": {
              "text": "#f85149",
              "bg": "rgba(218,54,51,0.1)",
              "border": "rgba(218,54,51,0.4)"
            }
          },
          "topicTag": {
            "text": "#58a6ff",
            "bg": "rgba(56,139,253,0.1)",
            "hoverBg": "rgba(56,139,253,0.2)",
            "activeBg": "rgba(56,139,253,0.15)"
          },
          "mergeBox": {
            "successIconBg": "rgba(46,160,67,0.1)",
            "successIconText": "#3fb950",
            "successIconBorder": "rgba(46,160,67,0.4)",
            "successIndicatorBg": "#238636",
            "successIndicatorBorder": "#2ea043",
            "mergedIconBg": "rgba(188,140,255,0.1)",
            "mergedIconText": "#a371f7",
            "mergedIconBorder": "rgba(188,140,255,0.4)",
            "mergedBoxBorder": "rgba(188,140,255,0.4)",
            "neutralIconBg": "rgba(201,209,217,0.1)",
            "neutralIconText": "#8b949e",
            "neutralIconBorder": "rgba(201,209,217,0.4)",
            "neutralIndicatorBg": "#484f58",
            "neutralIndicatorBorder": "#6e7681",
            "warningIconBg": "rgba(187,128,9,0.1)",
            "warningIconText": "#e3b341",
            "warningIconBorder": "rgba(187,128,9,0.4)",
            "warningBoxBorder": "rgba(187,128,9,0.4)",
            "warningMergeHighlight": "rgba(187,128,9,0.1)",
            "errorIconBg": "rgba(248,81,73,0.1)",
            "errorIconText": "#f85149",
            "errorIconBorder": "rgba(248,81,73,0.4)",
            "errorIndicatorBg": "#da3633",
            "errorIndicatorBorder": "#f85149"
          },
          "project": {
            "cardBg": "#161b22",
            "headerBg": "#0d1117",
            "sidebarBg": "#161b22",
            "gradientIn": "#161b22",
            "gradientOut": "rgba(22,27,34,0)"
          },
          "checks": {
            "bg": "hsla(216,28%,5%,1)",
            "textPrimary": "#c9d1d9",
            "textSecondary": "#8b949e",
            "textLink": "#58a6ff",
            "btnIcon": "#6e7681",
            "btnHoverIcon": "#c9d1d9",
            "btnHoverBg": "#30363d",
            "inputText": "#8b949e",
            "inputPlaceholderText": "#484f58",
            "inputFocusText": "#c9d1d9",
            "inputBg": "#0d1117",
            "donutError": "#f85149",
            "donutPending": "#d29922",
            "donutSuccess": "#2ea043",
            "donutNeutral": "#8b949e",
            "dropdownText": "#c9d1d9",
            "dropdownBg": "rgba(28,33,40,1)",
            "dropdownBorder": "#30363d",
            "dropdownHoverText": "#f0f6fc",
            "dropdownHoverBg": "#1f6feb",
            "dropdownBtnHoverText": "#f0f6fc",
            "dropdownBtnHoverBg": "#161b22",
            "scrollbarThumbBg": "#30363d",
            "headerLabelText": "#8b949e",
            "headerLabelOpenText": "#c9d1d9",
            "headerBorder": "#21262d",
            "headerIcon": "#6e7681",
            "lineText": "#8b949e",
            "lineNumText": "#8b949e",
            "lineTimestampText": "#8b949e",
            "lineHoverBg": "#161b22",
            "lineSelectedBg": "rgba(56,139,253,0.1)",
            "lineSelectedNumText": "#58a6ff",
            "lineDtFmText": "#0d1117",
            "lineDtFmBg": "#d29922",
            "gateBg": "rgba(132,83,6,0.15)",
            "gateText": "#8b949e",
            "gateWaitingText": "#e3b341",
            "stepHeaderOpenBg": "#161b22",
            "stepErrorText": "#f85149",
            "stepWarningText": "#e3b341",
            "loglineText": "#6e7681",
            "loglineNumText": "#8b949e",
            "loglineDebugText": "#bc8cff",
            "loglineErrorText": "#8b949e",
            "loglineErrorNumText": "#8b949e",
            "loglineErrorBg": "rgba(248,81,73,0.1)",
            "loglineWarningText": "#8b949e",
            "loglineWarningNumText": "#e3b341",
            "loglineWarningBg": "rgba(187,128,9,0.1)",
            "loglineCommandText": "#58a6ff",
            "loglineSectionText": "#56d364",
            "ansi": {
              "black": "#0d1117",
              "blackBright": "#161b22",
              "white": "#b1bac4",
              "whiteBright": "#b1bac4",
              "gray": "#6e7681",
              "red": "#ff7b72",
              "redBright": "#ffa198",
              "green": "#3fb950",
              "greenBright": "#56d364",
              "yellow": "#d29922",
              "yellowBright": "#e3b341",
              "blue": "#58a6ff",
              "blueBright": "#79c0ff",
              "magenta": "#bc8cff",
              "magentaBright": "#d2a8ff",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "introShelf": {
            "gradientLeft": "rgba(56,139,253,0.1)",
            "gradientRight": "rgba(46,160,67,0.1)",
            "gradientIn": "#0d1117",
            "gradientOut": "rgba(13,17,23,0)"
          },
          "marketingIcon": {
            "primary": "#79c0ff",
            "secondary": "#1f6feb"
          },
          "prettylights": {
            "syntax": {
              "comment": "#8b949e",
              "constant": "#79c0ff",
              "entity": "#d2a8ff",
              "storageModifierImport": "#c9d1d9",
              "entityTag": "#7ee787",
              "keyword": "#ff7b72",
              "string": "#a5d6ff",
              "variable": "#ffa657",
              "brackethighlighterUnmatched": "#f85149",
              "invalidIllegalText": "#f0f6fc",
              "invalidIllegalBg": "#8e1519",
              "carriageReturnText": "#f0f6fc",
              "carriageReturnBg": "#b62324",
              "stringRegexp": "#7ee787",
              "markupList": "#f2cc60",
              "markupHeading": "#1f6feb",
              "markupItalic": "#c9d1d9",
              "markupBold": "#c9d1d9",
              "markupDeletedText": "#ffdcd7",
              "markupDeletedBg": "#67060c",
              "markupInsertedText": "#aff5b4",
              "markupInsertedBg": "#033a16",
              "markupChangedText": "#ffdfb6",
              "markupChangedBg": "#5a1e02",
              "markupIgnoredText": "#c9d1d9",
              "markupIgnoredBg": "#1158c7",
              "metaDiffRange": "#d2a8ff",
              "brackethighlighterAngle": "#8b949e",
              "sublimelinterGutterMark": "#484f58",
              "constantOtherReferenceLink": "#a5d6ff"
            }
          },
          "codemirror": {
            "text": "#c9d1d9",
            "bg": "#0d1117",
            "guttersBg": "#0d1117",
            "guttermarkerText": "#0d1117",
            "guttermarkerSubtleText": "#6e7681",
            "linenumberText": "#8b949e",
            "cursor": "#f0f6fc",
            "selectionBg": "rgba(121,192,255,0.3)",
            "activelineBg": "#161b22",
            "matchingbracketText": "#c9d1d9",
            "linesBg": "#0d1117",
            "syntax": {
              "comment": "#8b949e",
              "constant": "#79c0ff",
              "entity": "#d2a8ff",
              "keyword": "#ff7b72",
              "storage": "#ff7b72",
              "string": "#a5d6ff",
              "support": "#79c0ff",
              "variable": "#ffa657"
            }
          },
          "ansi": {
            "black": "#484f58",
            "blackBright": "#6e7681",
            "white": "#b1bac4",
            "whiteBright": "#f0f6fc",
            "gray": "#6e7681",
            "red": "#ff7b72",
            "redBright": "#ffa198",
            "green": "#3fb950",
            "greenBright": "#56d364",
            "yellow": "#d29922",
            "yellowBright": "#e3b341",
            "blue": "#58a6ff",
            "blueBright": "#79c0ff",
            "magenta": "#bc8cff",
            "magentaBright": "#d2a8ff",
            "cyan": "#39c5cf",
            "cyanBright": "#56d4dd"
          }
        },
        "shadows": {
          "shadow": {
            "small": "0 0 transparent",
            "medium": "0 3px 6px #010409",
            "large": "0 8px 24px #010409",
            "extraLarge": "0 12px 48px #010409",
            "highlight": "0 0 transparent",
            "inset": "0 0 transparent"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px #0c2d6b"
            }
          },
          "autocomplete": {
            "shadow": "0 16px 32px rgba(1,4,9,0.85)"
          },
          "btn": {
            "shadow": "0 0 transparent",
            "insetShadow": "0 0 transparent",
            "focusShadow": "0 0 0 3px rgba(139,148,158,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(1,4,9,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(31,111,235,0.3)",
            "primary": {
              "shadow": "0 0 transparent",
              "insetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(1,4,9,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(240,246,252,0.03)",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(17,88,199,0.4)"
            },
            "danger": {
              "hoverShadow": "0 0 transparent",
              "hoverInsetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(182,35,36,0.4)"
            }
          },
          "dropdown": {
            "shadow": "0 16px 32px rgba(1,4,9,0.85)"
          },
          "overlay": {
            "shadow": "0 0 0 1px #30363d, 0 16px 32px rgba(1,4,9,0.85)"
          },
          "input": {
            "shadow": "0 0 transparent"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 #0d1117"
          },
          "toast": {
            "shadow": "0 8px 24px #010409"
          },
          "selectMenu": {
            "shadow": "0 0 18px rgba(1,4,9,0.4)"
          },
          "checks": {
            "inputShadow": "0 0 0 1px #21262d"
          }
        }
      },
      "dark_dimmed": {
        "colors": {
          "auto": {
            "black": "#cdd9e5",
            "white": "#1c2128",
            "gray": ["#22272e", "#2d333b", "#373e47", "#444c56", "#545d68", "#636e7b", "#768390", "#909dab", "#adbac7", "#cdd9e5"],
            "blue": ["#0f2d5c", "#143d79", "#1b4b91", "#255ab2", "#316dca", "#4184e4", "#539bf5", "#6cb6ff", "#96d0ff", "#c6e6ff"],
            "green": ["#113417", "#1b4721", "#245829", "#2b6a30", "#347d39", "#46954a", "#57ab5a", "#6bc46d", "#8ddb8c", "#b4f1b4"],
            "yellow": ["#452700", "#593600", "#6c4400", "#805400", "#966600", "#ae7c14", "#c69026", "#daaa3f", "#eac55f", "#fbe090"],
            "orange": ["#4d210c", "#682d0f", "#7f3913", "#94471b", "#ae5622", "#cc6b2c", "#e0823d", "#f69d50", "#ffbc6f", "#ffddb0"],
            "red": ["#78191b", "#78191b", "#922323", "#ad2e2c", "#c93c37", "#e5534b", "#f47067", "#ff938a", "#ffb8b0", "#ffd8d3"],
            "purple": ["#352160", "#472c82", "#5936a2", "#6b44bc", "#8256d0", "#986ee2", "#b083f0", "#dcbdfb", "#dcbdfb", "#eedcff"],
            "pink": ["#551639", "#69264a", "#7e325a", "#983b6e", "#ae4c82", "#c96198", "#e275ad", "#fc8dc7", "#ffb3d8", "#ffd7eb"]
          },
          "text": {
            "primary": "#adbac7",
            "secondary": "#768390",
            "tertiary": "#768390",
            "placeholder": "#545d68",
            "disabled": "#545d68",
            "inverse": "#22272e",
            "link": "#539bf5",
            "danger": "#e5534b",
            "success": "#6bc46d",
            "warning": "#daaa3f",
            "white": "#cdd9e5"
          },
          "icon": {
            "primary": "#adbac7",
            "secondary": "#636e7b",
            "tertiary": "#545d68",
            "info": "#539bf5",
            "danger": "#e5534b",
            "success": "#6bc46d",
            "warning": "#daaa3f"
          },
          "border": {
            "primary": "#444c56",
            "secondary": "#373e47",
            "tertiary": "#636e7b",
            "overlay": "#444c56",
            "inverse": "#cdd9e5",
            "info": "rgba(65,132,228,0.4)",
            "danger": "rgba(229,83,75,0.4)",
            "success": "rgba(87,171,90,0.4)",
            "warning": "rgba(174,124,20,0.4)"
          },
          "bg": {
            "canvas": "#22272e",
            "canvasMobile": "#1c2128",
            "canvasInverse": "#cdd9e5",
            "canvasInset": "hsla(215,15%,14%,1)",
            "primary": "#22272e",
            "secondary": "#22272e",
            "tertiary": "#2d333b",
            "overlay": "rgba(50,57,65,1)",
            "backdrop": "rgba(28,33,40,0.8)",
            "info": "rgba(65,132,228,0.1)",
            "infoInverse": "#4184e4",
            "danger": "rgba(229,83,75,0.1)",
            "dangerInverse": "#c93c37",
            "success": "rgba(70,149,74,0.1)",
            "successInverse": "#46954a",
            "warning": "rgba(174,124,20,0.1)",
            "warningInverse": "#ae7c14"
          },
          "state": {
            "hover": {
              "primaryBg": "#316dca",
              "primaryBorder": "#4184e4",
              "primaryText": "#cdd9e5",
              "primaryIcon": "#cdd9e5",
              "secondaryBg": "#2d333b",
              "secondaryBorder": "#2d333b"
            },
            "selected": {
              "primaryBg": "#316dca",
              "primaryBorder": "#4184e4",
              "primaryText": "#cdd9e5",
              "primaryIcon": "#cdd9e5"
            },
            "focus": {
              "border": "#4184e4"
            }
          },
          "fade": {
            "fg10": "rgba(205,217,229,0.1)",
            "fg15": "rgba(205,217,229,0.15)",
            "fg30": "rgba(205,217,229,0.3)",
            "fg50": "rgba(205,217,229,0.5)",
            "fg70": "rgba(205,217,229,0.7)",
            "fg85": "rgba(205,217,229,0.85)",
            "black10": "rgba(28,33,40,0.1)",
            "black15": "rgba(28,33,40,0.15)",
            "black30": "rgba(28,33,40,0.3)",
            "black50": "rgba(28,33,40,0.5)",
            "black70": "rgba(28,33,40,0.7)",
            "black85": "rgba(28,33,40,0.85)",
            "white10": "rgba(205,217,229,0.1)",
            "white15": "rgba(205,217,229,0.15)",
            "white30": "rgba(205,217,229,0.3)",
            "white50": "rgba(205,217,229,0.5)",
            "white70": "rgba(205,217,229,0.7)",
            "white85": "rgba(205,217,229,0.85)"
          },
          "alert": {
            "info": {
              "text": "#6cb6ff",
              "icon": "#6cb6ff",
              "bg": "rgba(65,132,228,0.1)",
              "border": "rgba(65,132,228,0.4)"
            },
            "warn": {
              "text": "#daaa3f",
              "icon": "#daaa3f",
              "bg": "rgba(174,124,20,0.1)",
              "border": "rgba(174,124,20,0.4)"
            },
            "error": {
              "text": "#f47067",
              "icon": "#f47067",
              "bg": "rgba(229,83,75,0.1)",
              "border": "rgba(229,83,75,0.4)"
            },
            "success": {
              "text": "#6bc46d",
              "icon": "#6bc46d",
              "bg": "rgba(70,149,74,0.1)",
              "border": "rgba(70,149,74,0.4)"
            }
          },
          "autocomplete": {
            "rowBorder": "#444c56"
          },
          "blankslate": {
            "icon": "hsla(213,11%,42%,1)"
          },
          "btn": {
            "text": "#adbac7",
            "bg": "#373e47",
            "border": "#444c56",
            "hoverBg": "#444c56",
            "hoverBorder": "#768390",
            "activeBg": "hsla(213,12%,27%,1)",
            "activeBorder": "#636e7b",
            "selectedBg": "#2d333b",
            "focusBg": "#373e47",
            "focusBorder": "#768390",
            "primary": {
              "text": "#ffffff",
              "bg": "#347d39",
              "border": "#46954a",
              "hoverBg": "#46954a",
              "hoverBorder": "#57ab5a",
              "selectedBg": "#347d39",
              "disabledText": "rgba(205,217,229,0.5)",
              "disabledBg": "rgba(52,125,57,0.6)",
              "disabledBorder": "rgba(0,0,0,0)",
              "focusBg": "#347d39",
              "focusBorder": "#57ab5a",
              "icon": "#cdd9e5",
              "counterBg": "rgba(205,217,229,0.2)"
            },
            "outline": {
              "text": "#539bf5",
              "hoverText": "#539bf5",
              "hoverBg": "#444c56",
              "hoverBorder": "#539bf5",
              "hoverCounterBg": "rgba(205,217,229,0.2)",
              "selectedText": "#cdd9e5",
              "selectedBg": "#1b4b91",
              "selectedBorder": "rgba(205,217,229,0.1)",
              "disabledText": "rgba(83,155,245,0.5)",
              "disabledBg": "#22272e",
              "disabledCounterBg": "rgba(49,109,202,0.05)",
              "focusBorder": "#539bf5",
              "counterBg": "rgba(49,109,202,0.1)"
            },
            "danger": {
              "text": "#e5534b",
              "hoverText": "#ffffff",
              "hoverBg": "#c93c37",
              "hoverBorder": "#e5534b",
              "hoverCounterBg": "rgba(255,255,255,0.2)",
              "selectedText": "#ffffff",
              "selectedBg": "#ad2e2c",
              "selectedBorder": "rgba(205,217,229,0.1)",
              "disabledText": "rgba(229,83,75,0.5)",
              "disabledBg": "#22272e",
              "disabledCounterBg": "rgba(201,60,55,0.05)",
              "focusBorder": "#e5534b",
              "counterBg": "rgba(201,60,55,0.1)",
              "icon": "#e5534b",
              "hoverIcon": "#cdd9e5"
            },
            "counterBg": "#444c56"
          },
          "counter": {
            "text": "#adbac7",
            "bg": "#444c56",
            "primary": {
              "text": "#adbac7",
              "bg": "#636e7b"
            },
            "secondary": {
              "text": "#768390",
              "bg": "rgba(118,131,144,0.2)"
            }
          },
          "label": {
            "border": "#444c56",
            "primary": {
              "text": "#909dab",
              "border": "#636e7b"
            },
            "secondary": {
              "text": "#768390",
              "border": "#444c56"
            },
            "info": {
              "text": "#4184e4",
              "border": "rgba(65,132,228,0.4)"
            },
            "success": {
              "text": "#57ab5a",
              "border": "rgba(70,149,74,0.4)"
            },
            "warning": {
              "text": "#daaa3f",
              "border": "rgba(242,211,91,0.4)"
            },
            "danger": {
              "text": "#e5534b",
              "border": "rgba(229,83,75,0.4)"
            },
            "orange": {
              "text": "#cc6b2c",
              "border": "rgba(204,107,44,0.4)"
            }
          },
          "input": {
            "bg": "#22272e",
            "contrastBg": "rgba(28,33,40,0.5)",
            "border": "#373e47",
            "disabledBg": "#2d333b",
            "disabledBorder": "#444c56",
            "warningBorder": "#c69026",
            "errorBorder": "#e5534b",
            "tooltip": {
              "success": {
                "text": "#6bc46d",
                "bg": "rgba(38,50,49,1)",
                "border": "rgba(51,90,59,1)"
              },
              "warning": {
                "text": "#daaa3f",
                "bg": "rgba(48,48,43,1)",
                "border": "rgba(98,78,34,1)"
              },
              "error": {
                "text": "#f47067",
                "bg": "rgba(53,43,49,1)",
                "border": "rgba(124,59,59,1)"
              }
            }
          },
          "avatar": {
            "bg": "rgba(205,217,229,0.1)",
            "border": "rgba(205,217,229,0.1)",
            "stackFade": "#444c56",
            "stackFadeMore": "#373e47"
          },
          "toast": {
            "text": "#adbac7",
            "bg": "#444c56",
            "border": "#636e7b",
            "icon": "#cdd9e5",
            "iconBg": "#316dca",
            "iconBorder": "#4184e4",
            "success": {
              "text": "#adbac7",
              "border": "#636e7b",
              "icon": "#cdd9e5",
              "iconBg": "#46954a",
              "iconBorder": "#57ab5a"
            },
            "warning": {
              "text": "#adbac7",
              "border": "#636e7b",
              "icon": "#cdd9e5",
              "iconBg": "#ae7c14",
              "iconBorder": "#c69026"
            },
            "danger": {
              "text": "#adbac7",
              "border": "#636e7b",
              "icon": "#cdd9e5",
              "iconBg": "#c93c37",
              "iconBorder": "#e5534b"
            },
            "loading": {
              "text": "#adbac7",
              "border": "#636e7b",
              "icon": "#cdd9e5",
              "iconBg": "#636e7b",
              "iconBorder": "#768390"
            }
          },
          "timeline": {
            "text": "#909dab",
            "badgeBg": "#22272e",
            "badgeSuccessBorder": "#46954a",
            "targetBadgeBorder": "#316dca",
            "targetBadgeShadow": "#1b4b91"
          },
          "selectMenu": {
            "borderSecondary": "#444c56",
            "backdropBg": "rgba(28,33,40,0.5)",
            "backdropBorder": "#545d68",
            "tapHighlight": "rgba(68,76,86,0.5)",
            "tapFocusBg": "#143d79"
          },
          "box": {
            "blueBorder": "#1b4b91",
            "rowYellowBg": "rgba(235,196,64,0.1)",
            "rowBlueBg": "rgba(108,182,255,0.1)",
            "headerBlueBg": "#22272e",
            "headerBlueBorder": "#444c56",
            "borderInfo": "rgba(65,132,228,0.4)",
            "bgInfo": "rgba(65,132,228,0.1)",
            "borderWarning": "rgba(174,124,20,0.4)",
            "bgWarning": "rgba(174,124,20,0.1)"
          },
          "branchName": {
            "text": "#adbac7",
            "icon": "#909dab",
            "bg": "rgba(83,155,245,0.1)",
            "link": {
              "text": "#539bf5",
              "icon": "#539bf5",
              "bg": "rgba(83,155,245,0.1)"
            }
          },
          "markdown": {
            "codeBg": "rgba(205,217,229,0.15)",
            "frameBorder": "hsla(213,12%,35%,1)",
            "blockquoteBorder": "hsla(213,12%,35%,1)",
            "tableBorder": "hsla(213,12%,35%,1)",
            "tableTrBorder": "hsla(213,12%,26%,1)"
          },
          "menu": {
            "headingText": "#768390",
            "borderActive": "#f78166",
            "bgActive": "#2d333b"
          },
          "sidenav": {
            "selectedBg": "#373e47",
            "borderActive": "#f78166"
          },
          "header": {
            "text": "rgba(205,217,229,0.7)",
            "bg": "#2d333b",
            "logo": "#cdd9e5"
          },
          "filterItem": {
            "barBg": "hsla(214,13%,18%,1)"
          },
          "hiddenTextExpander": {
            "bg": "#373e47",
            "bgHover": "#444c56"
          },
          "dragAndDrop": {
            "border": "hsla(213,12%,25%,1)"
          },
          "uploadEnabled": {
            "border": "hsla(213,12%,35%,1)",
            "borderFocused": "hsla(216,61%,57%,1)"
          },
          "previewableCommentForm": {
            "border": "hsla(213,12%,25%,1)"
          },
          "underlinenav": {
            "border": "rgba(68,76,86,0)",
            "borderHover": "#444c56",
            "borderActive": "#f78166",
            "text": "#768390",
            "textHover": "#adbac7",
            "textActive": "#adbac7",
            "icon": "#636e7b",
            "iconHover": "#adbac7",
            "iconActive": "#adbac7",
            "counterText": "#768390",
            "counterBg": "rgba(118,131,144,0.2)"
          },
          "verifiedBadge": {
            "text": "#57ab5a",
            "bg": "rgba(87,171,90,0.1)",
            "border": "rgba(87,171,90,0.4)"
          },
          "socialCount": {
            "bg": "#373e47"
          },
          "tooltip": {
            "text": "#cdd9e5",
            "bg": "#636e7b"
          },
          "headerSearch": {
            "bg": "#22272e",
            "border": "#373e47"
          },
          "searchKeyword": {
            "hl": "rgba(174,124,20,0.4)"
          },
          "diffstat": {
            "neutralBg": "#444c56",
            "neutralBorder": "rgba(205,217,229,0.1)",
            "deletionBg": "#c93c37",
            "deletionBorder": "#e5534b",
            "additionBg": "#347d39",
            "additionBorder": "#46954a"
          },
          "mktg": {
            "success": "rgba(61,137,66,1)",
            "info": "rgba(56,119,213,1)",
            "bgShadeGradient": {
              "top": "rgba(28,33,40,0.065)",
              "bottom": "rgba(28,33,40,0)"
            },
            "btn": {
              "bg": {
                "top": "hsla(228,82%,66%,1)",
                "bottom": "#4969ed"
              },
              "bgOverlay": {
                "top": "hsla(228,74%,59%,1)",
                "bottom": "#3355e0"
              },
              "text": "#cdd9e5",
              "primary": {
                "bg": {
                  "top": "hsla(137,56%,46%,1)",
                  "bottom": "#2ea44f"
                },
                "bgOverlay": {
                  "top": "hsla(134,60%,38%,1)",
                  "bottom": "#22863a"
                },
                "text": "#cdd9e5"
              },
              "enterprise": {
                "bg": {
                  "top": "hsla(249,100%,72%,1)",
                  "bottom": "#6f57ff"
                },
                "bgOverlay": {
                  "top": "hsla(248,65%,63%,1)",
                  "bottom": "#614eda"
                },
                "text": "#cdd9e5"
              },
              "outline": {
                "text": "#cdd9e5",
                "border": "rgba(205,217,229,0.3)",
                "hover": {
                  "text": "#cdd9e5",
                  "border": "rgba(205,217,229,0.5)"
                },
                "focus": {
                  "border": "#cdd9e5",
                  "borderInset": "rgba(205,217,229,0.5)"
                }
              },
              "dark": {
                "text": "#cdd9e5",
                "border": "rgba(205,217,229,0.3)",
                "hover": {
                  "text": "#cdd9e5",
                  "border": "rgba(205,217,229,0.5)"
                },
                "focus": {
                  "border": "#cdd9e5",
                  "borderInset": "rgba(205,217,229,0.5)"
                }
              }
            }
          },
          "filesExplorerIcon": "#636e7b",
          "hlAuthorBg": "#0f2d5c",
          "hlAuthorBorder": "#1b4b91",
          "logoSubdued": "#444c56",
          "discussionBorder": "hsla(125,2%,29%,1)",
          "discussionBgSuccess": "rgba(70,149,74,0.1)",
          "actionsWorkflowTableStickyBg": "rgba(34,39,46,0.95)",
          "repoLanguageColorBorder": "rgba(205,217,229,0.2)",
          "codeSelectionBg": "rgba(108,182,255,0.3)",
          "highlight": {
            "text": "#ffd467",
            "bg": "rgba(204,143,44,0.38)"
          },
          "blob": {
            "lineHighlightBg": "rgba(198,144,38,0.15)",
            "lineHighlightBorder": "#daaa3f"
          },
          "diff": {
            "addition": {
              "text": "#6bc46d",
              "bg": "rgba(70,149,74,0.2)",
              "border": "#2b6a30"
            },
            "deletion": {
              "text": "#e5534b",
              "bg": "rgba(201,60,55,0.2)",
              "border": "#ad2e2c"
            },
            "change": {
              "text": "#daaa3f",
              "bg": "#452700",
              "border": "#966600"
            }
          },
          "diffBlob": {
            "numText": "rgba(205,217,229,0.3)",
            "numHoverText": "rgba(205,217,229,0.6)",
            "addition": {
              "numText": "#57ab5a",
              "numHoverText": "#8ddb8c",
              "numBg": "rgba(70,149,74,0.1)",
              "lineBg": "rgba(70,149,74,0.2)",
              "wordBg": "rgba(70,149,74,0.55)"
            },
            "deletion": {
              "numText": "#e5534b",
              "numHoverText": "#ff938a",
              "numBg": "rgba(201,60,55,0.1)",
              "lineBg": "rgba(201,60,55,0.2)",
              "wordBg": "rgba(201,60,55,0.5)"
            },
            "hunk": {
              "text": "#768390",
              "numBg": "rgba(83,155,245,0.15)",
              "lineBg": "rgba(83,155,245,0.1)"
            },
            "emptyBlockBg": "#2d333b",
            "selectedLineHighlightBg": "rgba(174,124,20,0.1)",
            "selectedLineHighlightBorder": "#ae7c14",
            "expander": {
              "icon": "#768390",
              "hoverIcon": "#cdd9e5",
              "hoverBg": "#316dca"
            },
            "commentButton": {
              "icon": "#cdd9e5",
              "bg": "#316dca",
              "gradientBg": "hsla(216,61%,54%,1)"
            }
          },
          "globalNav": {
            "logo": "#cdd9e5",
            "bg": "#2d333b",
            "text": "#adbac7",
            "icon": "#adbac7",
            "inputBg": "#22272e",
            "inputBorder": "#373e47",
            "inputIcon": "#373e47",
            "inputPlaceholder": "#545d68"
          },
          "footerInvertocat": {
            "octicon": "#444c56",
            "octiconHover": "#636e7b"
          },
          "prState": {
            "draft": {
              "text": "#768390",
              "bg": "rgba(118,131,144,0.1)",
              "border": "rgba(118,131,144,0.4)"
            },
            "open": {
              "text": "#57ab5a",
              "bg": "rgba(87,171,90,0.1)",
              "border": "rgba(87,171,90,0.4)"
            },
            "merged": {
              "text": "#986ee2",
              "bg": "rgba(176,131,240,0.1)",
              "border": "rgba(176,131,240,0.4)"
            },
            "closed": {
              "text": "#e5534b",
              "bg": "rgba(201,60,55,0.1)",
              "border": "rgba(201,60,55,0.4)"
            }
          },
          "topicTag": {
            "text": "#539bf5",
            "bg": "rgba(65,132,228,0.1)",
            "hoverBg": "rgba(65,132,228,0.2)",
            "activeBg": "rgba(65,132,228,0.15)"
          },
          "mergeBox": {
            "successIconBg": "rgba(70,149,74,0.1)",
            "successIconText": "#57ab5a",
            "successIconBorder": "rgba(70,149,74,0.4)",
            "successIndicatorBg": "#347d39",
            "successIndicatorBorder": "#46954a",
            "mergedIconBg": "rgba(176,131,240,0.1)",
            "mergedIconText": "#986ee2",
            "mergedIconBorder": "rgba(176,131,240,0.4)",
            "mergedBoxBorder": "rgba(176,131,240,0.4)",
            "neutralIconBg": "rgba(173,186,199,0.1)",
            "neutralIconText": "#768390",
            "neutralIconBorder": "rgba(173,186,199,0.4)",
            "neutralIndicatorBg": "#545d68",
            "neutralIndicatorBorder": "#636e7b",
            "warningIconBg": "rgba(174,124,20,0.1)",
            "warningIconText": "#daaa3f",
            "warningIconBorder": "rgba(174,124,20,0.4)",
            "warningBoxBorder": "rgba(174,124,20,0.4)",
            "warningMergeHighlight": "rgba(174,124,20,0.1)",
            "errorIconBg": "rgba(229,83,75,0.1)",
            "errorIconText": "#e5534b",
            "errorIconBorder": "rgba(229,83,75,0.4)",
            "errorIndicatorBg": "#c93c37",
            "errorIndicatorBorder": "#e5534b"
          },
          "project": {
            "cardBg": "#2d333b",
            "headerBg": "#22272e",
            "sidebarBg": "#2d333b",
            "gradientIn": "#2d333b",
            "gradientOut": "rgba(45,51,59,0)"
          },
          "checks": {
            "bg": "hsla(215,15%,14%,1)",
            "textPrimary": "#adbac7",
            "textSecondary": "#768390",
            "textLink": "#539bf5",
            "btnIcon": "#636e7b",
            "btnHoverIcon": "#adbac7",
            "btnHoverBg": "#444c56",
            "inputText": "#768390",
            "inputPlaceholderText": "#545d68",
            "inputFocusText": "#adbac7",
            "inputBg": "#22272e",
            "donutError": "#e5534b",
            "donutPending": "#c69026",
            "donutSuccess": "#46954a",
            "donutNeutral": "#768390",
            "dropdownText": "#adbac7",
            "dropdownBg": "rgba(50,57,65,1)",
            "dropdownBorder": "#444c56",
            "dropdownHoverText": "#cdd9e5",
            "dropdownHoverBg": "#316dca",
            "dropdownBtnHoverText": "#cdd9e5",
            "dropdownBtnHoverBg": "#2d333b",
            "scrollbarThumbBg": "#444c56",
            "headerLabelText": "#768390",
            "headerLabelOpenText": "#adbac7",
            "headerBorder": "#373e47",
            "headerIcon": "#636e7b",
            "lineText": "#768390",
            "lineNumText": "#768390",
            "lineTimestampText": "#768390",
            "lineHoverBg": "#2d333b",
            "lineSelectedBg": "rgba(65,132,228,0.1)",
            "lineSelectedNumText": "#539bf5",
            "lineDtFmText": "#22272e",
            "lineDtFmBg": "#c69026",
            "gateBg": "rgba(128,84,0,0.15)",
            "gateText": "#768390",
            "gateWaitingText": "#daaa3f",
            "stepHeaderOpenBg": "#2d333b",
            "stepErrorText": "#e5534b",
            "stepWarningText": "#daaa3f",
            "loglineText": "#636e7b",
            "loglineNumText": "#768390",
            "loglineDebugText": "#b083f0",
            "loglineErrorText": "#768390",
            "loglineErrorNumText": "#768390",
            "loglineErrorBg": "rgba(229,83,75,0.1)",
            "loglineWarningText": "#768390",
            "loglineWarningNumText": "#daaa3f",
            "loglineWarningBg": "rgba(174,124,20,0.1)",
            "loglineCommandText": "#539bf5",
            "loglineSectionText": "#6bc46d",
            "ansi": {
              "black": "#22272e",
              "blackBright": "#2d333b",
              "white": "#909dab",
              "whiteBright": "#909dab",
              "gray": "#636e7b",
              "red": "#f47067",
              "redBright": "#ff938a",
              "green": "#57ab5a",
              "greenBright": "#6bc46d",
              "yellow": "#c69026",
              "yellowBright": "#daaa3f",
              "blue": "#539bf5",
              "blueBright": "#6cb6ff",
              "magenta": "#b083f0",
              "magentaBright": "#dcbdfb",
              "cyan": "#76e3ea",
              "cyanBright": "#b3f0ff"
            }
          },
          "introShelf": {
            "gradientLeft": "rgba(65,132,228,0.1)",
            "gradientRight": "rgba(70,149,74,0.1)",
            "gradientIn": "#22272e",
            "gradientOut": "rgba(34,39,46,0)"
          },
          "marketingIcon": {
            "primary": "#6cb6ff",
            "secondary": "#316dca"
          },
          "prettylights": {
            "syntax": {
              "comment": "#768390",
              "constant": "#6cb6ff",
              "entity": "#dcbdfb",
              "storageModifierImport": "#adbac7",
              "entityTag": "#8ddb8c",
              "keyword": "#f47067",
              "string": "#96d0ff",
              "variable": "#f69d50",
              "brackethighlighterUnmatched": "#e5534b",
              "invalidIllegalText": "#cdd9e5",
              "invalidIllegalBg": "#922323",
              "carriageReturnText": "#cdd9e5",
              "carriageReturnBg": "#ad2e2c",
              "stringRegexp": "#8ddb8c",
              "markupList": "#eac55f",
              "markupHeading": "#316dca",
              "markupItalic": "#adbac7",
              "markupBold": "#adbac7",
              "markupDeletedText": "#ffd8d3",
              "markupDeletedBg": "#78191b",
              "markupInsertedText": "#b4f1b4",
              "markupInsertedBg": "#1b4721",
              "markupChangedText": "#ffddb0",
              "markupChangedBg": "#682d0f",
              "markupIgnoredText": "#adbac7",
              "markupIgnoredBg": "#255ab2",
              "metaDiffRange": "#dcbdfb",
              "brackethighlighterAngle": "#768390",
              "sublimelinterGutterMark": "#545d68",
              "constantOtherReferenceLink": "#96d0ff"
            }
          },
          "codemirror": {
            "text": "#adbac7",
            "bg": "#22272e",
            "guttersBg": "#22272e",
            "guttermarkerText": "#22272e",
            "guttermarkerSubtleText": "#636e7b",
            "linenumberText": "#768390",
            "cursor": "#cdd9e5",
            "selectionBg": "rgba(108,182,255,0.3)",
            "activelineBg": "#2d333b",
            "matchingbracketText": "#adbac7",
            "linesBg": "#22272e",
            "syntax": {
              "comment": "#768390",
              "constant": "#6cb6ff",
              "entity": "#dcbdfb",
              "keyword": "#f47067",
              "storage": "#f47067",
              "string": "#96d0ff",
              "support": "#6cb6ff",
              "variable": "#f69d50"
            }
          },
          "ansi": {
            "black": "#545d68",
            "blackBright": "#636e7b",
            "white": "#909dab",
            "whiteBright": "#cdd9e5",
            "gray": "#636e7b",
            "red": "#f47067",
            "redBright": "#ff938a",
            "green": "#57ab5a",
            "greenBright": "#6bc46d",
            "yellow": "#c69026",
            "yellowBright": "#daaa3f",
            "blue": "#539bf5",
            "blueBright": "#6cb6ff",
            "magenta": "#b083f0",
            "magentaBright": "#dcbdfb",
            "cyan": "#39c5cf",
            "cyanBright": "#56d4dd"
          }
        },
        "shadows": {
          "shadow": {
            "small": "0 0 transparent",
            "medium": "0 3px 6px #1c2128",
            "large": "0 8px 24px #1c2128",
            "extraLarge": "0 12px 48px #1c2128",
            "highlight": "0 0 transparent",
            "inset": "0 0 transparent"
          },
          "state": {
            "focus": {
              "shadow": "0 0 0 3px #143d79"
            }
          },
          "autocomplete": {
            "shadow": "0 16px 32px rgba(28,33,40,0.85)"
          },
          "btn": {
            "shadow": "0 0 transparent",
            "insetShadow": "0 0 transparent",
            "focusShadow": "0 0 0 3px rgba(118,131,144,0.3)",
            "shadowActive": "inset 0 0.15em 0.3em rgba(28,33,40,0.15)",
            "shadowInputFocus": "0 0 0 0.2em rgba(49,109,202,0.3)",
            "primary": {
              "shadow": "0 0 transparent",
              "insetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(46,164,79,0.4)"
            },
            "outline": {
              "hoverShadow": "0 1px 0 rgba(28,33,40,0.1)",
              "hoverInsetShadow": "inset 0 1px 0 rgba(205,217,229,0.03)",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(37,90,178,0.4)"
            },
            "danger": {
              "hoverShadow": "0 0 transparent",
              "hoverInsetShadow": "0 0 transparent",
              "selectedShadow": "0 0 transparent",
              "focusShadow": "0 0 0 3px rgba(173,46,44,0.4)"
            }
          },
          "dropdown": {
            "shadow": "0 16px 32px rgba(28,33,40,0.85)"
          },
          "overlay": {
            "shadow": "0 0 0 1px #444c56, 0 16px 32px rgba(28,33,40,0.85)"
          },
          "input": {
            "shadow": "0 0 transparent"
          },
          "avatar": {
            "childShadow": "-2px -2px 0 #22272e"
          },
          "toast": {
            "shadow": "0 8px 24px #1c2128"
          },
          "selectMenu": {
            "shadow": "0 0 18px rgba(28,33,40,0.4)"
          },
          "checks": {
            "inputShadow": "0 0 0 1px #373e47"
          }
        }
      }
    }
  }
};